import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import Checkbox from 'core/views/checkbox';
import Dropdown from 'core/views/dropdown';


export default Backbone.View.extend({
  events: {
    'click input[type="submit"]': 'submit',
    'click a.btn-primary': 'submit',
    'click a.btn-cancel': 'cancel',
  },

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.rendered = false;
    this.resource_name = this.$el.data('resource-name');
    this.defaults = {};

    // Templates
    this.label_tmpl = _.template($('#form-label-template').html(), { variable: 'data' });
  },

  render: function () {
    if (!this.rendered) {
      this.reset();
      // Render checkboxes and dropdowns
      _.each($('.check', this.$el), function (checkbox_el) {
        if (!$(checkbox_el).data('checkbox_view')) {
          new Checkbox({ el: checkbox_el });
        }
      });
      _.each($('.form-dropdown'), function (dropdown_el) {
        new Dropdown({ el: dropdown_el });
      });
    }

    // Fill in form values, build defaults
    _.each(this.model.attributes, function (value, key) {
      var element = $('[name="' + key + '"]', this.$el);
      if (element.length === 0 || element.is('[readonly]')) {
        return;
      }
      if (element.is('[type="checkbox"]')) {
        var check_or_not = this.model.get(key) ? 'check' : 'uncheck';
        element.siblings('a').data('checkbox_view')[check_or_not]();
      } else if (element.is('select')) {
        var $dropdown = element.siblings('.form-dropdown');
        $dropdown.data('dropdown-view').set_selected_value(value);
      } else {
        element.val(value);
      }
    }, this);

    // Display errors
    if (Object.keys(this.errors).length > 0) {
      this.$el.addClass('has-errors');
    }
    _.each(this.errors, function (value, key) {
      var element = $('[name="' + key + '"]', this.$el);
      element.before(this.label_tmpl({
        has_error: true,
        label: value.join('<br/>'),
      }));
    }, this);
    _.each(this.successes, function (value, key) {
      var element = $('[name="' + key + '"]', this.$el);
      element.before(this.label_tmpl({
        has_success: true,
        label: value.join('<br/>'),
      }));
    }, this);

    this.rendered = true;
  },

  reset: function () {
    this.errors = {};
    this.successes = {};
    $('.has-error, .has-success', this.$el).remove();
    this.$el.removeClass('has-errors');
  },

  error: function (model, xhr) {
    this.reset();
    this.errors = xhr.responseJSON[this.resource_name];
    this.render();
  },

  success: function (model) {
    this.reset();
    this.trigger('submitted', model);
  },

  cancel: function (e) {
    e.preventDefault();
    this.reset();
    this.trigger('cancelled');
  },

  submit: function (e) {
    e.preventDefault();
    var data = this.serialize();
    if (Object.keys(data).length !== 0) {
      this.model.save(data, { error: this.error, success: this.success });
    } else {
      this.trigger('submitted', this.model);
    }
  },

  serialize: function () {
    var arr = this.$el.serializeArray(),
      data = _.object(_.pluck(arr, 'name'), _.pluck(arr, 'value'));
    // A little extra work is needed to get invisible checkbox values
    _.each($('[type="checkbox"]', this.$el), function (element) {
      var checkbox_view = $(element).siblings('a').data('checkbox_view');
      data[checkbox_view.name] = checkbox_view.checked();
    });
    return data;
  }
});



// WEBPACK FOOTER //
// ./static/js/views/form.js